import React, { useEffect } from 'react';
import {
  IconWrapper,
  ImageWrapper,
  IQuestionStatus,
  IQuestionStatusObject,
  IStyles,
  pxToRem,
  pxTovW,
} from '@geneo2-web/shared-ui';
import { Box, Button, Collapse, Divider, Typography } from '@mui/material';
import { MultiSubjectSection } from '@protos/learning_management/lms.db_pb';
import {
  getSubjectColorBySubjectId,
  getSubjectImageBySubjectId,
  getSubjectNameFromEnum,
} from '../../utils_assessment/assessmentUtils';
import { SubjectList } from '@protos/user_management/ums.login.apis_pb';

const styles: IStyles = {
  root: {
    width: '100%',
    p: { xs: pxToRem(10), md: pxTovW(14) },
    border: '2px solid #F8C807',
    boxSizing: 'border-box',
    borderRadius: pxToRem(8),
    display: 'flex',
    flexDirection: 'column',
    gap: pxToRem(10),
    backgroundColor: 'white',
  },
  buttonContainer: {
    width: { xs: pxToRem(24), md: pxTovW(36), lg: pxTovW(32) },
    height: { xs: pxToRem(24), md: pxTovW(36), lg: pxTovW(32) },
    borderRadius: { xs: '5px', md: pxToRem(5) },
    justifyContent: 'center',
    alignItems: 'center',
    display: 'flex',
    '&:disabled': {
      cursor: 'default',
      color: '#007CDC',
    },
    // boxShadow:
    //   'inset 0px -2px 6px rgba(0, 0, 0, 0.5), 0px 0px 2px rgba(0, 0, 0, 0.5)',
  },
  label: {
    width: { xs: pxToRem(14), md: pxTovW(18) },
    height: { xs: pxToRem(14), md: pxTovW(18) },
    borderRadius: '50%',
  },
};
interface IProps {
  currentPage: number;
  totalPages: number;
  onPageChange?: (page: number) => void;
  // showPreviousNextButtons: boolean;
  questionStatusArray: IQuestionStatusObject[];
  // maxButtonsToDisplay?: number;
  sectionNo?: number;
  activeSectionNo?: number;
  sectionInfo?: MultiSubjectSection;
  learnSubjects?: SubjectList[];
}
export default function QuestionsSummaryPagination(props: IProps) {
  const {
    currentPage,
    totalPages,
    onPageChange,
    // showPreviousNextButtons,
    questionStatusArray,
    // maxButtonsToDisplay,
    sectionNo,
    activeSectionNo,
    sectionInfo,
    learnSubjects,
  } = props;
  const getButtonStyle = (
    status: IQuestionStatus,
    currentPage: number,
    index: number
  ) => {
    const hasSection = sectionNo && activeSectionNo;
    // const isSectionActive =
    //   sectionNo && activeSectionNo ? sectionNo === activeSectionNo : false;
    const onCurrentPage = hasSection
      ? sectionNo === activeSectionNo && currentPage - 1 === index
      : currentPage - 1 === index;
    console.log({ status, currentPage, index, onCurrentPage });
    if (status === IQuestionStatus.Correct) {
      return {
        backgroundColor: 'white',
        color: '#0AA34F',
        border: onCurrentPage ? '2px solid #0AA34F' : 'none',
      };
    } else if (status === IQuestionStatus.Incorrect) {
      return {
        backgroundColor: 'white',
        color: '#F23F3F',
        border: onCurrentPage ? '2px solid #F23F3F' : 'none',
      };
    } else if (status === IQuestionStatus.Attempted) {
      return {
        backgroundColor: onCurrentPage ? '#007CDC' : '#007CDC',
        color: onCurrentPage ? 'white' : 'white',
        border: onCurrentPage ? '2px solid #0B5691' : 'none',
        boxShadow: onCurrentPage ? '0px 0px 9px #00000085' : 'none',
      };
    } else if (status === IQuestionStatus.NotAttempted) {
      return {
        backgroundColor: onCurrentPage ? '#EFEFEF' : '#EFEFEF',
        color: onCurrentPage ? ' #828282' : ' #949494',
        border: onCurrentPage ? '2px solid #828282' : '1px solid #C7C6C6',
        boxShadow: onCurrentPage ? '0px 0px 9px #00000052' : 'none',
      };
    }
  };
  const isSectionActive =
    sectionNo && activeSectionNo ? sectionNo === activeSectionNo : false;
  const [expanded, setExpanded] = React.useState(
    sectionInfo ? isSectionActive : true
  );
  const subjectColor =
    learnSubjects &&
    sectionInfo &&
    getSubjectColorBySubjectId(sectionInfo?.subjectId, learnSubjects);
  const subjectIcon =
    learnSubjects &&
    sectionInfo &&
    getSubjectImageBySubjectId(sectionInfo?.subjectId, learnSubjects);
  useEffect(() => {
    if (sectionInfo && sectionNo === activeSectionNo) {
      setExpanded(true); // only OPEN, never close
    }
  }, [activeSectionNo, sectionNo, sectionInfo]);
  return (
    <Box
      sx={{
        ...styles.root,
        borderColor: subjectColor ? subjectColor : '#F8C807',
      }}
    >
      <Box
        display={'flex'}
        alignItems={'center'}
        gap={pxToRem(8)}
        onClick={() => {
          if (sectionInfo) setExpanded((prev) => !prev);
        }}
        sx={{ cursor: sectionInfo ? 'pointer' : 'default' }}
      >
        {subjectIcon ? (
          <ImageWrapper
            name={'subjects/english'}
            path={subjectIcon}
            type="png"
            parentFolder="icons"
            styles={{
              width: { xs: pxToRem(33), md: pxTovW(54) },
              height: { xs: pxToRem(33), md: pxTovW(54) },
            }}
          />
        ) : (
          <IconWrapper
            name={'file-group'}
            size="md"
            parentFolder="icons"
            type="png"
            customSx={{
              width: { xs: pxToRem(33), md: pxTovW(54) },
              height: { xs: pxToRem(33), md: pxTovW(54) },
            }}
          />
        )}

        <Box
          display={'flex'}
          flexDirection="column"
          gap={2}
          justifyContent="center"
          flex={1}
          minWidth={0}
        >
          <Typography
            variant="cardText"
            sx={{
              display: '-webkit-box',
              // WebkitLineClamp: 1,
              WebkitBoxOrient: 'vertical',
              overflow: 'hidden',
              textOverflow: 'ellipsis',
              width: '100%',
            }}
          >
            {sectionInfo
              ? getSubjectNameFromEnum(sectionInfo.subject) + ' '
              : ''}
            Questions Summary
          </Typography>
          {sectionInfo?.sectionTitle && (
            <Typography
              variant="smallText"
              color="primary.main"
              sx={{
                width: '100%',
                display: '-webkit-box',
                WebkitBoxOrient: 'vertical',
                overflow: 'hidden',
                textOverflow: 'ellipsis',
                wordBreak: 'break-word',
              }}
            >
              {sectionInfo?.sectionTitle}
            </Typography>
          )}
        </Box>
      </Box>
      <Collapse in={expanded} timeout="auto" unmountOnExit>
        <Box display="flex" flexDirection="column" gap={pxToRem(10)}>
          <Divider />
          <Box
            sx={{
              display: 'flex',
              flexDirection: 'column',
              gap: pxToRem(10),
              marginY: pxToRem(5),
            }}
          >
            <Typography variant="smallText">
              Total Questions:{totalPages}
            </Typography>
            <Box sx={{ display: 'flex', flexWrap: 'wrap', gap: pxToRem(8) }}>
              {totalPages &&
                questionStatusArray.map((item, index) => (
                  <PaginationButton
                    key={index}
                    onClick={onPageChange}
                    number={index + 1}
                    statusStyles={getButtonStyle(
                      item.statusInfo,
                      currentPage,
                      index
                    )}
                    disabled={
                      sectionNo === activeSectionNo && currentPage === index + 1
                    }
                  />
                ))}
            </Box>
          </Box>
          <Divider />
          <Box display={'flex'} gap={pxToRem(10)}>
            <Box display={'flex'} alignItems={'center'} gap={pxToRem(5)}>
              <Box sx={{ background: '#007CDC', ...styles.label }}></Box>
              <Typography variant="smallText">Attempted</Typography>
            </Box>
            <Box display={'flex'} alignItems={'center'} gap={pxToRem(5)}>
              <Box sx={{ background: '#828282', ...styles.label }}></Box>
              <Typography variant="smallText">Not-Attempted</Typography>
            </Box>
          </Box>
        </Box>
      </Collapse>
    </Box>
  );
}
interface IButtonProps {
  number: number;
  onClick?: (page: number) => void;
  statusStyles: any;
  disabled?: boolean;
}
const PaginationButton = React.memo((props: IButtonProps) => {
  const { number, onClick, statusStyles, disabled } = props;
  // console.log('my button', { number, statusStyles });
  return (
    <Button
      disabled={disabled}
      onClick={() => onClick && onClick(number)}
      sx={{
        ...statusStyles,
        ...styles.buttonContainer,
        transition: 'transform 0.2s ease-in-out',
        '&:hover': {
          backgroundColor: statusStyles.backgroundColor,
          color: statusStyles.color,
          border: statusStyles.border,
          transform: `scale(1.2)`,
        },
      }}
    >
      <Typography sx={{ color: statusStyles.color }}>{number}</Typography>
    </Button>
  );
});
